import { memo, useMemo } from 'react';
import generateTestId from './generateTestId';
import generateTestIdProps from './generateTestIdProps';
import { Team } from './Team';
import { Provider } from './testIdContext';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Test id provider
 * @param { FC<TestIdProviderProps> } props - Test id provider props
 * @throws { Error } Throws an error when team isn't provider
 * @returns { JSX.Element }
 */
var TestIdProvider = /*#__PURE__*/memo(function (_ref) {
  var children = _ref.children,
      team = _ref.team,
      project = _ref.project;

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- needed
  if (!team) {
    throw new Error("Property `team` wasn't provided. Test id cannot be generated without it.");
  }

  if (process.env.NODE_ENV !== 'production' && !Object.keys(Team).includes(team)) {
    throw new Error("Provided team '".concat(team, "' isn't allowed. Please select predefined team."));
  }

  var getTestId = useMemo(function () {
    return generateTestId({
      team: team,
      project: project
    });
  }, [team, project]);
  var getTestIdProps = useMemo(function () {
    return generateTestIdProps({
      team: team,
      project: project
    });
  }, [team, project]);
  return /*#__PURE__*/_jsx(Provider, {
    value: {
      getTestId: getTestId,
      getTestIdProps: getTestIdProps
    },
    children: children
  });
});
export default TestIdProvider;